import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'mui-loader',
  templateUrl: './mui-loader.component.html',
  styles: [
    `
      :host {
        display: flex;
        width: 100%;
      }
    `
  ]
})
export class MuiLoader {
  @Input() size: 'normal' | 'small' | 'large' = 'normal';
  @HostBinding('attr.role') readonly role = 'progressbar';
}
